import { useEffect, useMemo } from 'react';
import { FaKey, FaSyncAlt } from 'react-icons/fa';
import { Button } from '../../../../../../components/button/button';
import { Select } from '../../../../../../components/select/select';
import { HasAccess } from '../../../../../../features/has-access/has-access';
import { useLang } from '../../../../../../hooks/use-lang';
import { useModalParams } from '../../../../../../hooks/use-modal-params';
import { useQueryParams } from '../../../../../../hooks/use-query-params';
import { useBranchesStore } from '../../../../../../store/use-branch-store';
import { useIikoStore } from '../../../../../../store/use-iiko-store';
import { MenuIikoCredentialsModal } from './menu-iiko-credentials-modal/menu-iiko-credentials-modal';
import s from './menu-iiko-header.module.css';

export const MenuIikoHeader = () => {
  const { t, getLocale } = useLang();
  const iikoSyncModal = useModalParams('iikoSync');
  const { syncMenu } = useIikoStore();
  const { place, fetchBranches } = useBranchesStore();
  const { addQueryParams, getQueryParams } = useQueryParams();
  const params = getQueryParams();
  const branchId = params.branchId;

  useEffect(() => {
    fetchBranches({ is_by_company: true, since_id: 0, n: 1000 });
  }, []);

  const branchIdValues = useMemo(() => {
    return (
      place
        ?.filter((item) => !!item.iiko_organization_id)
        .map((item) => ({ id: String(item.id), value: getLocale(item.name) })) || []
    );
  }, [place]);

  const selectedBranch = branchIdValues.find((item) => item.id === branchId);

  return (
    <div className={s.feature}>
      <h2>iiko</h2>
      <Select
        options={branchIdValues}
        placeholder={t('Филиал')}
        value={selectedBranch}
        onSelect={(e) => addQueryParams({ branchId: e.id })}
      />
      <HasAccess service="menu" permissions={['write']}>
        <div className={s.controls}>
          {branchId && (
            <Button variant="secondary" onClick={() => syncMenu(branchId)} size="lg">
              {t('Синхронизировать')}
              <FaSyncAlt />
            </Button>
          )}

          <Button onClick={() => iikoSyncModal.handleOpenModal()} size="lg">
            {t('Ключи')} <FaKey />
          </Button>

          {iikoSyncModal.isOpen && (
            <MenuIikoCredentialsModal onClose={() => iikoSyncModal.handleCloseModal()} />
          )}
        </div>
      </HasAccess>
    </div>
  );
};
